<template>
  <div class="wl-managerWordDetail-web">
    <div class="managerWord-center-content">
      <div class="new-breadcrumb-trail">
        <h2>管理办法</h2>
        <div class="crumbs-text">
          <i class="wl-icon-zhuye1"></i>
          <span>当前位置：</span>
          <span @click="goHome">网站首页</span>
          <span>></span>
          <span @click="goNews">
            <span>管理办法</span>
          </span>
          <span>></span>
          <span>{{examOutlineInfo.Title}}</span>
        </div>
      </div>
      <div class="new-center-detail">
        <div class="new-center-title">
          <h3 class="h3-news-title">{{examOutlineInfo.Title}}</h3>
          <p class="p-news-date">发布时间：{{dateCreated}}</p>
          <p class="p-news-date" style="text-align: right;" v-if="downloadUrl"> <a :href="downloadUrl" class="a-download-text">下载</a></p>

         
          <div class="class-news-content">
            <p v-html="examOutlineInfo.Content"></p>
          </div>
        </div>
      </div>
      <div style="margin-left:250px;">
        <!-- <studySource></studySource> -->
      </div>
    </div>
    <div class="ph-new-center-content">
      <div class="crumbs-text">
        <div style="padding:0 20px;">
          <i class="wl-icon-zhuye1"></i>
          <span @click="goHome" style="cursor: pointer;">首页</span>
          <span>></span>
          <span @click="getNewCenter(1)">管理办法</span>
        </div>
      </div>
      <div class="new-center-detail">
        <div class="new-center-title">
          <h3 class="h3-news-title">{{examOutlineInfo.Title}}</h3>
          <p class="p-news-date">发布时间：{{dateCreated}}
          </p>
          <p class="p-news-date" style="text-align: right;" v-if="downloadUrl"> <a :href="downloadUrl" class="a-download-text">下载</a></p>
        
          <div class="class-news-content">
            <p v-html="examOutlineInfo.Content"></p>
          </div>
        </div>
      </div>
      <div style="margin-left:250px;">
        <!-- <studySource></studySource> -->
      </div>
    </div>
  </div>
</template>

<script>
import studySource from "page/component/school/studySource.vue";
export default {
  name: "Detail",
  components: {
    studySource
  },
  props: {
    examOutLineId: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      examOutlineInfo: {},
      dateCreated:"",
      isShow: 1,
      imgcen: require("../../assets/images/bg-news.png"),
      // downloadUrl:""
    };
  },
  created() {
    this.getNewsInfo();
  },
  computed: {
    downloadUrl(){
      if(this.examOutlineInfo.DocUrl){
        return this.examOutlineInfo.DocUrl;
      }
      return "";
    }
  },
  methods: {
    getNewCenter(num) {
      this.$router.push({
        name: "managerWordList",
        params: {
          isTab: num
        }
      });
    },
    goHome() {
      this.$router.push({
        name: "xHome"
      });
    },
    goNews() {
      this.$router.push({
        name: "managerWordList"
      });
    },
    getNewsInfo() {
      var that = this;
      this.$http
        .post("/api/XOrg/ExamOutLineCom/getExamOutLineInfo", {
          id: that.examOutLineId
        })
        .then(function(rst) {
          if (rst.code > 0) {
            that.examOutlineInfo = rst.examOutlineInfo;
            that.dateCreated = rst.dateCreated;
            // that.downloadUrl = rst.examOutlineInfo.DocUrl+"?response-content-disposition=attachment;filename="+rst.examOutlineInfo.DocTitle;
           
          } else {
            that.$message.warning(rst.msg);
          }
        });
    }
  }
};
</script>
